import {addLicense as addAM4License, useTheme as useAM4Theme} from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import {addLicense as addAM5License} from "@amcharts/amcharts5";
import {useTheme as useAM5Theme} from "@amcharts/amcharts4/core";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

export const amchartsMixin = {
    methods: {
        initializeAmcharts(){
            addAM4License("CH237653684")
            useAM4Theme(am4themes_animated)
        },
        initializeAmchartsNoAnimation(){
            addAM4License("CH237653684")
        },
        initializeAM5Charts() {
            // Add license for the charts
            addAM5License("AM5C-394244706")

            // Add license for the maps
            addAM5License("AM5M-394244706")

            useAM5Theme(am5themes_Animated)
        },
        initializeAM5ChartsNoAnimation() {
            // Add license for the charts
            addAM5License("AM5C-394244706")

            // Add license for the maps
            addAM5License("AM5M-394244706")
        }
    }
}
